<template>
  <v-sheet class="mt-5 pa-5" tile>
    <conflicts-list :items="items" :type="type" @show="showTask" />

    <v-dialog v-model="dialog" persistent max-width="1400px">
      <view-event-task
        v-if="taskId"
        :id="taskId"
        @updated="cancelDialogAndRefresh"
        @removed="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      ></view-event-task>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { types } from '@/modules/statistic/components/Scheduling/Conflicts/ConflictsList';

export default {
  name: 'RequestVacationsReports',

  components: {
    ViewEventTask: () =>
      import('@/modules/plannings/components/Event/ViewEventTask'),
    ConflictsList: () =>
      import(
        '@/modules/statistic/components/Scheduling/Conflicts/ConflictsList'
      )
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'vacations',
      validator: prop => Object.values(types).includes(prop)
    }
  },

  data() {
    return {
      dialog: false,
      taskId: null
    };
  },

  methods: {
    showTask({ task_id }) {
      this.taskId = task_id;
      this.dialog = true;
    },

    cancelDialog() {
      this.dialog = false;
      this.taskId = null;
    },

    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.refreshData();
    }
  }
};
</script>
